import { NgStyle } from '@angular/common';
import { Component, inject, type OnInit, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { environment } from '@environments/environment';
import { NgbCollapseModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { KeyboardClickableDirective } from '@common/directives/keyboard-clickable.directive';
import { SharedNavbarService } from '@system/layout/nav-bar/nav-bar.service';
import { AuthService } from '@infra/auth/auth.service';
import { SecurityService } from '@infra/auth/security.service';

@Component({
  selector: 'app-system-app-nav-bar',
  templateUrl: './system-nav-bar.component.html',
  imports: [KeyboardClickableDirective, NgbCollapseModule, NgbDropdownModule, NgStyle, TranslatePipe, RouterLink],
})
export class SystemNavBarComponent implements OnInit {
  private readonly securityService = inject(SecurityService);
  authService = inject(AuthService);
  translate = inject(TranslateService);
  router = inject(Router);
  nav = inject(SharedNavbarService);

  isMenuCollapsed = signal(true);
  notifications: Notification[];
  apiVersion: string;
  version: string;
  companyName: string;
  loggedInUserAvatarUrl: string;
  loggedInUserEmail: string;
  loggedInUserFullName: string;
  isLoggedInUserImage: boolean;
  loggedInUserId: string;

  constructor() {
    this.version = environment.version;
    this.loggedInUserAvatarUrl = null;
    this.isLoggedInUserImage = false;
    this.notifications = [];
    this.loggedInUserId = null;

    this.nav.getVersion().subscribe((version: string) => {
      this.apiVersion = version;
    });
  }

  ngOnInit(): void {
    const currentUser = this.securityService.currentUser.getValue();
    if (!currentUser) return;

    if (currentUser.avatarUrl) {
      this.isLoggedInUserImage = true;
      this.loggedInUserAvatarUrl = currentUser.avatarUrl;
    } else {
      this.isLoggedInUserImage = false;
      this.loggedInUserAvatarUrl = '';
    }
    this.loggedInUserEmail = currentUser.email;
    this.loggedInUserFullName = this.getNameString(currentUser.firstName, currentUser.lastName);
    this.loggedInUserId = currentUser.id;
  }

  backToDashboard(): void {
    this.router.navigate(['/admin']);
  }

  logout(event: Event): void {
    event.preventDefault();
    this.authService.logout();
  }

  private getNameString(firstName?: string, lastName?: string): string {
    if (firstName && lastName) {
      return firstName[0].toUpperCase() + lastName[0].toUpperCase();
    }
    return '';
  }
}
